export default __webpack_public_path__ + "static/polkadot-c2f9ac00016bc56932f38bc4f4bff84d.png";